import type { CSSProperties } from 'react'
import type { SearchAnchor } from './types'

const MATCH_PANEL_WIDTH = 240
const MATCH_PANEL_GAP = 8
const MATCH_PANEL_VIEWPORT_PADDING = 16

export function getMatchPanelStyle(
  anchor: SearchAnchor,
  trigger: HTMLButtonElement | null
): CSSProperties {
  const triggerRect = trigger?.getBoundingClientRect()
  const viewportWidth =
    typeof window === 'undefined'
      ? anchor.left + anchor.width + MATCH_PANEL_WIDTH + MATCH_PANEL_VIEWPORT_PADDING
      : window.innerWidth
  const viewportHeight = typeof window === 'undefined' ? 720 : window.innerHeight
  const width = Math.min(
    MATCH_PANEL_WIDTH,
    Math.max(1, viewportWidth - MATCH_PANEL_VIEWPORT_PADDING * 2)
  )
  const triggerRight = triggerRect?.right ?? anchor.left + anchor.width - 12
  const triggerBottom = triggerRect?.bottom ?? anchor.top + anchor.height
  const left = Math.min(
    Math.max(triggerRight - width, MATCH_PANEL_VIEWPORT_PADDING),
    viewportWidth - MATCH_PANEL_VIEWPORT_PADDING - width
  )
  const top = triggerBottom + MATCH_PANEL_GAP

  return {
    position: 'fixed',
    left,
    top,
    width,
    maxHeight: Math.max(160, viewportHeight - top - MATCH_PANEL_VIEWPORT_PADDING),
    overflowY: 'auto',
  }
}
